import { render, staticRenderFns } from "./base64image.vue?vue&type=template&id=4ca2a27a&scoped=true"
import script from "./base64image.vue?vue&type=script&lang=js"
export * from "./base64image.vue?vue&type=script&lang=js"
import style0 from "./base64image.vue?vue&type=style&index=0&id=4ca2a27a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca2a27a",
  null
  
)

export default component.exports